import { render, staticRenderFns } from "./LandingBenefitsItem.html?vue&type=template&id=4939a267&scoped=true&"
import script from "./LandingBenefitsItem.ts?vue&type=script&lang=ts&"
export * from "./LandingBenefitsItem.ts?vue&type=script&lang=ts&"
import style0 from "./LandingBenefitsItem.scss?vue&type=style&index=0&id=4939a267&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4939a267",
  null
  
)

export default component.exports